var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "#5F5F5F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 64.4584C17.1984 64.4584 3.54175 50.8018 3.54175 34.0001C3.54175 17.1984 17.1984 3.54175 34.0001 3.54175C50.8018 3.54175 64.4584 17.1984 64.4584 34.0001C64.4584 50.8018 50.8018 64.4584 34.0001 64.4584ZM34.0001 7.79175C19.5501 7.79175 7.79175 19.5501 7.79175 34.0001C7.79175 48.4501 19.5501 60.2084 34.0001 60.2084C48.4501 60.2084 60.2084 48.4501 60.2084 34.0001C60.2084 19.5501 48.4501 7.79175 34.0001 7.79175Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5116 45.135C44.1433 45.135 43.775 45.05 43.435 44.8233L34.6516 39.5817C32.47 38.2783 30.855 35.4167 30.855 32.895V21.2783C30.855 20.1167 31.8183 19.1533 32.98 19.1533C34.1416 19.1533 35.105 20.1167 35.105 21.2783V32.895C35.105 33.915 35.955 35.4167 36.8333 35.9267L45.6166 41.1683C46.6366 41.7633 46.9483 43.0667 46.3533 44.0867C45.9283 44.7667 45.22 45.135 44.5116 45.135Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.50259b8617ef197aad3fa052fb979b71.svg";
export { ForwardRef as ReactComponent };